<template>
  <div class="content">
    <van-nav-bar title="" @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <div class="content-box">
      <div class="money-box">
        <span class="hint">我的余额</span><span class="money-num">￥{{balance}}</span>
      </div>
      <div class="div-bg">
        <div class="money-sec-box">
          <div>
            <span class="price-bs">￥</span>
            <input placeholder="手动输入充值金额" class="money-input" v-model="money" type="number" @input="valueChange" />
          </div>

          <div class="input-box">
            <div :class="money==item?'active-btn': ''" class="input-num" v-for="(item,index) in moneyList" :key="index" @click="selectBtn(index,item)">{{item}} 元</div>
          </div>
        </div>
        <div class="submit-btn" @click="submitClick">确定充值</div>
        <div class="xy-txt">点击确认充值，即表示您已同意 <span style="color: #ffa500;">《充值协议》</span></div>
      </div>

    </div>
  </div>
</template>

<script>
import QS from 'qs'
import { rechargeMoney,orderPayMoney } from '@/api/wallet'
export default {
  name: "recharge",
  data (){
    return {
      appTheme:this.$store.state.appTheme,
      money: '',
      moneyList: [50, 100, 300, 500, 1000, 3000],
      active: -1,
      balance: 0
    }
  },
  beforeCreate: function() {
    // console.log('1')
    window.document.body.style.backgroundColor= '#fff'
  },
  beforeDestroy: function() {
    // console.log('2')
    window.document.body.style.backgroundColor= ''
  },
  created() {
    this.balance= this.$store.state.userInfo.balance
  },
  methods:{
    valueChange(e){
      e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
      const reg = /[^\d.]/g;

      // 只能是数字和小数点，不能是其他输入
      e.target.value = e.target.value.replace(reg, "");

      // 保证第一位只能是数字，不能是点
      e.target.value = e.target.value.replace(/^\./g, "");
      // 小数只能出现1位
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 小数点后面保留2位
      e.target.value = e.target.value.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      );
      this.money = e.target.value
      console.log(e.target.value)
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    selectBtn(index, item){
      console.log(index,item)
      this.active = index
      this.money = item
    },
    submitClick(){
      var that = this

       if(this.money == ''){
         this.$toast('请输入金额')
         return false
       }
      // QS.stringify(postData)
      var data = {
        amount:that.money
      }

      rechargeMoney(data).then(res => {
        if(res.code == 200)
        {
          var id = res.data.id
          this.payMoney(id)
          console.log('res',res.data)
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    payMoney(id){
      var type = 'recharge'
      orderPayMoney(id,type).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          var url = res.data.url
          window.location.href=url
          // console.log('res',res.data)
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.van-hairline--bottom::after {
  border-bottom-width: 0
}
.div-bg{
  padding-top: 40px;border-radius: 50px 50px 0px 0px;background: #ffffff;position: relative;margin-top: -30px;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.money-box{
  font-size: 24px;padding: 70px 0;background: #FDD80D;text-align: center;
  color: #282828;
  .hint{
    margin-right: 20px;display: inline-block;
  }
  .money-num{
    color: #282828;
    font-size: 50px;font-weight: bold;
  }
}
.money-sec-box{
  background: #ffffff;
}
.money-input{
  width: 85%; border:none; height: 88px;line-height: 88px;margin: 30px auto;padding: 0 10px;
  font-weight: bold;
  font-size: 60px;
  //text-align: center;
}
.price-bs{
  font-size: 44px;font-weight: bold;
  color: #282828;
}
.input-box{
  width: 85%;
  flex-wrap: wrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;margin: 0 auto;padding: 40px 0;
  .input-num{
    width: 25%;display: inline-block; border: 1PX solid #55BB3A; margin: 20px 20px;color: #55BB3A; padding: 20px 0;border-radius: 5px;text-align: center;
  }
  .active-btn{
    background: #55BB3A;color: #FFFFFF;
  }
}
input::-webkit-input-placeholder {
  font-size: 44px;color: #C3C3C3;text-align: left;font-weight: normal;
}
input:-moz-placeholder {
  font-size: 44px;color: #C3C3C3;font-weight: normal;text-align: left;
}
input:-ms-input-placeholder {
  font-size: 44px;color: #C3C3C3;font-weight: normal;text-align: left;
}
.submit-btn{
  width: 85%;background: #FDD80D;text-align: center;
  border-radius: 42px;
  margin: 50px auto 0;padding: 25px 0;font-size: 32px;font-weight: bold;
  color: #282828;
}
.xy-txt{
  color: #D3D3D3;font-size: 24px;margin-top: 20px;text-align: center;padding-bottom: 20px;
}
</style>
